import { OnlineItemEditController } from "./item-edit.controller";
import { OnlineItemEdit } from "./item-edit.service";

angular
    .module("thor.online-item-edit", [])
    .service("onlineItemEdit", OnlineItemEdit)
    .component("onlineItemEdit", {
        bindings: {
            getTranslationStatus: "&",
            isSaving: "=",
            readOnly: "<",
            saleCurrency: "<",
            selectedTargetLanguage: "<",
            sourceLang: "<"
        },
        template: require("./item-edit.html"),
        controller: OnlineItemEditController,
        controllerAs: "onlineItemEditCtrl"
    });
